// Litepicker's dist files are legacy globals-style scripts (`var Litepicker
// = ...`), not real ES/CJS modules — every one of them references `window`
// unconditionally at the top level, which crashes if anything (like Vite's
// dependency pre-bundler) tries to execute or interop-detect them under
// Node. Loading it as a classic <script> tag via a Vite `?url` asset
// reference sidesteps all of that: the browser just runs it as a normal
// global script, exactly how the library expects to be used.
// @ts-ignore -- `?url` asset import, no JS content is executed by Vite
import litepickerUrl from "litepicker/dist/nocss/litepicker.js?url";

declare global {
  interface Window {
    Litepicker: any;
  }
}

let loadPromise: Promise<any> | null = null;

export function loadLitepicker(): Promise<any> {
  if (window.Litepicker) return Promise.resolve(window.Litepicker);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = litepickerUrl;
    script.onload = () => resolve(window.Litepicker);
    script.onerror = () => reject(new Error("Failed to load litepicker"));
    document.head.appendChild(script);
  });

  return loadPromise;
}
